import { createAsyncThunk } from "@reduxjs/toolkit"
import { allWarhousesUnit, transferWarehouseUnit, warehouseDocumentDetailUnit, warehouseDocumentUnit, warhouseProductsUnit, warhouseUpdateUnit, wasteProductsUnit } from "../units/warhouseUnits"
import { clearData } from "../store/gridDataSlice"

export const warhouseProductsAction = createAsyncThunk('warehouse/products', async(params, {dispatch, rejectWithValue}) => {
    try {
        const response = await warhouseProductsUnit(params)
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})


export const allWarehouseListAction = createAsyncThunk('warehouse/all', async(_, {dispatch, rejectWithValue}) => {
    try {
        const response = await allWarhousesUnit()
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})



export const warhouseUpdateAction = createAsyncThunk('warehouse/update', async(body, {dispatch, rejectWithValue}) => {
    try {
        const response = await warhouseUpdateUnit(body)
        dispatch(warhouseProductsAction())
        dispatch(clearData('warehouseDocumentData'))
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})



export const transferWarehouseAction = createAsyncThunk('warehouse/transfer', async(body, {dispatch, rejectWithValue}) => {
    try {
        const response = await transferWarehouseUnit(body)
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})

export const warehouseDocumentDetailAction = createAsyncThunk('warehouse/document/detail', async(date, {dispatch, rejectWithValue}) => {
    try {
        const formatDate = date.format('YYYY-MM-DD')
        const response = await warehouseDocumentDetailUnit(formatDate)
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})

export const warehouseDocumentAction = createAsyncThunk('warehouse/document', async(id, {dispatch, rejectWithValue}) => {
    try {
        const response = await warehouseDocumentUnit(id)
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})



export const wasteProductsAction = createAsyncThunk('waaste/products', async(_, {dispatch, rejectWithValue}) => {
    try {
        const response = await wasteProductsUnit()
        return response
    } catch (e){
        return rejectWithValue(e.request?.response || 'Some error')
    }
})
